<template>
    <div
        @click="onClick"
        :class="parentClass"
        class="navbar__link navbar__link--help"
    >
        <span class="navbar__link-text--help">{{ $t('help') | capitalize }}</span>
        <i class="icon icon-help_circle navbar__link-icon--help"/>
        <div class="help-dropdown">
            <div class="help-dropdown__wrapper">
                <div class="help-dropdown__icon-row">
                    <a
                        href="https://suport.superbet.ro/hc/ro"
                        target="_blank"
                        class="help-dropdown__icon-box"
                    >
                        <i class="icon icon-help_circle"/>
                        <div class="help-dropdown__icon-box-name">{{ $t('FAQ') }}</div>
                    </a>
                    <div
                        @click="onShowLiveChat"
                        class="help-dropdown__icon-box"
                    >
                        <i class="icon icon-live_chat_help"/>
                        <div class="help-dropdown__icon-box-name">{{ $t('Live Chat') }}</div>
                    </div>
                    <a
                        :href="`mailto:${config.countrySpecific.footer.email}`"
                        class="help-dropdown__icon-box"
                    >
                        <i class="icon icon-email"/>
                        <div class="help-dropdown__icon-box-name">{{ $t('E-mail') }}</div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import config from '@config';

    export default {
        name: 'Help',
        data() {
            return {
                parentClass: 'collapsed'
            };
        },
        created() {
            this.config = config;
        },
        mounted() {
            document.addEventListener('click', this.onClickOutside);
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            onClick(event) {
                if (event.target.className.includes('navbar__link-text--help')
                    || event.target.className.includes('navbar__link-icon--help')
                ) {
                    this.parentClass = this.parentClass === 'expanded'
                        ? 'collapsed'
                        : 'expanded';
                }
            },
            onClickOutside(event) {
                if (!this.$el.contains(event.target)) {
                    this.parentClass = 'collapsed';
                }
            },
            onShowLiveChat() {
                this.showHelp();
            }
        },
        destroyed() {
            document.removeEventListener('click', this.onClickOutside);
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/layout/header/components/Help.vue